import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Lightbox from 'yet-another-react-lightbox'
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import HotelsReviewcomponents from '../HotelsReviewcomponents';
import { numberWithCommas } from '../../../../../components/commonClass/CommonValidation';
import HotelAddTravellerForm from '../HotelAddTravellerForm';
import HotelGalleryViewModel from '../../../DetailScreen/Hotels/HotelGalleryViewModel';

const BookingRoomDetails = ({
    getDataList,
    setFormValue,
    formValue,
    setFormError,
    formError,
    setInsertCollection,
    insertCollection,
    setInitialData,
    initialData,
    setIntOtherData,
    intOtherData,
    handleContinue,
    personcount,
    getNight,
    setPassengersData,
    convenienceDetail,
    checkLastCancellationDateForHold
}: any) => {
    const location = useLocation();

    const [galleryviewModal, setGalleryViewModal] = useState(false);
    const [galleryViewData, setGalleryViewData] = useState([]);

    const [isOpenImage, setIsOpenImage] = useState(false);
    const [indexImage, setIndexImage] = useState(1);
    const [srcImage, setSrcImage] = useState<any>([]);

    const PreviewImageOnClick = (imageList: any, imageIndex: any) => {
        setSrcImage([]);
        imageList?.map((value: any) => {
            setSrcImage((current: any) => [...current, { ...srcImage, src: value }])
        })
        setIsOpenImage(true);
        setIndexImage(imageIndex)
    }

    const openGalleryPopupDataViewAll = (imageList: any) => {
        setGalleryViewModal(true);
        setGalleryViewData(imageList);
    }

    const formattedDate = (date: any) => {
        const inputDate = new Date(date);
        const options: any = { day: '2-digit', month: 'short' };
        const optionsDay: any = { weekday: 'short' };
        const formattedDate = inputDate?.toLocaleDateString('en-GB', options);
        const dayName = inputDate.toLocaleDateString('en-GB', optionsDay);
        return { day: dayName, date: formattedDate };
    }

    //#region convenience fee calculation
    const convenienceData = useMemo(() => {
        let convinienceFeeCharged = 0
        if (convenienceDetail?.isConvinienceFee) {
            if (!convenienceDetail?.isConvinienceFeePercentage) {
                convinienceFeeCharged = Math.round((convenienceDetail?.convenienceFeesWeb + (convenienceDetail?.convenienceFeesWeb * 18 / 100)) * personcount?.PaxRooms?.length);
            }
            else {
                const convenienceFeePercentage = getDataList?.[0]?.rooms?.[0]?.grandTotal * convenienceDetail?.convenienceFeesWeb / 100
                convinienceFeeCharged = Math.round(convenienceFeePercentage + (convenienceFeePercentage * 18 / 100));
            }
        }

        return { convinienceFeeCharged: convinienceFeeCharged }
    }, [convenienceDetail, getDataList, personcount])
    //#endregion

    return (
        <>
            {getDataList?.map((el: any, index: any) => (
                <div className="row" key={index}>
                    <div className="detailContainer">
                        <div className="features mt-0">
                            <div className="hotelInfo">
                                <div className="col-lg-4 col-md-4 col-sm-4 hotelImg">

                                    <div className="room-gallery">
                                        <div className="lg-image">
                                            <img
                                                src={el?.rooms?.[0]?.images?.[0] || ""}
                                                alt="Main Room"
                                                onClick={(e) => PreviewImageOnClick(el?.rooms?.[0]?.images, 0)}
                                                onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                            />
                                        </div>

                                        <div className="thumbs">
                                            <div className="thumb">
                                                <img
                                                    src={el?.rooms?.[0]?.images?.[1] || ""}
                                                    alt=""
                                                    onClick={(e) => PreviewImageOnClick(el?.rooms?.[0]?.images, 1)}
                                                    onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                />
                                            </div>
                                            <div className="thumb">
                                                <img
                                                    src={el?.rooms?.[0]?.images?.[2] || ""}
                                                    alt=""
                                                    onClick={(e) => PreviewImageOnClick(el?.rooms?.[0]?.images, 2)}
                                                    onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                />
                                            </div>
                                            <div className="thumb view-all">
                                                <img
                                                    src={el?.rooms?.[0]?.images?.[3] || ""}
                                                    alt=""
                                                    onClick={(e) => openGalleryPopupDataViewAll(el?.rooms?.[0]?.images)}
                                                    onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                />
                                                <span
                                                    onClick={(e) => openGalleryPopupDataViewAll(el?.rooms?.[0]?.images)}
                                                >View All</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-8 col-md-8 col-sm-8">
                                    <div className="detail">
                                        <h4 className="placename">{el?.hotelDetails?.[0]?.hotelName}</h4>
                                        <div className="rating mb-1">
                                            {(() => {
                                                const stars = [];
                                                const starRating = el?.hotelDetails?.[0]?.hotelRating;
                                                for (let i = 0; i < starRating; i++) {
                                                    stars.push(<>&nbsp;<i className="fa-solid fa-star" key={i}></i></>);
                                                }
                                                for (let i = 0; i < 5 - starRating > (0 ? 5 - starRating > 0 : 0); i++) {
                                                    stars.push(<>&nbsp;<i className="fa-regular fa-star" key={i}></i></>);
                                                }
                                                return stars;
                                            })()}
                                        </div>
                                        <div className="hotelLocation"><i className="fa-solid fa-location-dot"></i>{el?.hotelDetails?.[0]?.address}</div>
                                        <div className="duration"><span><i className="fa-solid fa-moon"></i>&nbsp;{getNight}&nbsp;Nights</span>&nbsp;<span><i className="fa-solid fa-sun"></i>&nbsp;{getNight + 1}&nbsp;Days</span></div>
                                        <div className="time">
                                            <div>
                                                <h5>Check In </h5>
                                                <h4>{formattedDate(location?.state?.CheckIn)?.date}</h4>
                                                <p>{formattedDate(location?.state?.CheckIn)?.day}&nbsp;|&nbsp;{el?.hotelDetails?.[0]?.checkInTime}</p>
                                            </div>
                                            <div>
                                                <h5>Check Out </h5>
                                                <h4>{formattedDate(location?.state?.CheckOut)?.date}</h4>
                                                <p>{formattedDate(location?.state?.CheckOut)?.day}&nbsp;|&nbsp;{el?.hotelDetails?.[0]?.checkOutTime}</p>
                                            </div>
                                            <div>
                                                <h5>{(personcount?.PaxRooms?.reduce((sum: any, entry: any) => sum + entry?.Adults, 0)) + (personcount?.PaxRooms?.reduce((sum: any, entry: any) => sum + entry?.Children, 0))}&nbsp;Guests</h5>
                                                <h5>{personcount?.PaxRooms?.length}&nbsp;Room</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <HotelsReviewcomponents details={el?.rooms} rateConditions={el.rateConditions} />
                    </div>
                    <div className="rightSec">
                        <div className="priceSummary">
                            <div className="title pr">
                                <h5 className="mb-0">Price Summary</h5>
                                <div className="person">
                                    <span><i className="fa-solid fa-user"></i>&nbsp;{personcount?.PaxRooms?.reduce((sum: any, entry: any) => sum + entry?.Adults, 0)}</span>
                                    &nbsp;{(personcount?.PaxRooms?.reduce((sum: any, entry: any) => sum + entry?.Children, 0)) > 0
                                        && <span><i className="fa-solid fa-children"></i>&nbsp;{personcount?.PaxRooms?.reduce((sum: any, entry: any) => sum + entry?.Children, 0)}</span>}
                                </div>
                            </div>
                            <div className="priceSummaryList">
                                <ul>
                                    <li>
                                        <p>{personcount?.PaxRooms?.length}&nbsp;Room&nbsp;<span>x</span>&nbsp;{getNight}&nbsp;Night</p>
                                        <div className="price"><span>₹</span> {el?.rooms?.[0]?.priceWithMarkup}</div>
                                    </li>

                                    <li>
                                        <p>Taxes and Surcharges <span>+</span> </p>
                                        <div className="price"><span>₹</span>&nbsp;{el?.rooms?.[0]?.totalTax}</div>
                                    </li>

                                    {
                                        convenienceData?.convinienceFeeCharged > 0 &&
                                        <li>
                                            <p>Convinience fees charged <span>+</span> </p>
                                            <div className="price"><span>₹</span>&nbsp;{convenienceData?.convinienceFeeCharged}</div>
                                        </li>
                                    }

                                    <li className="total">
                                        <h4>Grand Total</h4>
                                        <div className="price">₹{numberWithCommas((getDataList?.[0]?.rooms?.[0]?.grandTotal) + (convenienceData?.convinienceFeeCharged ? convenienceData?.convinienceFeeCharged : 0))}</div>
                                    </li>

                                    {/* <li className="total">
                                        <h4>Grand Total</h4>
                                        <div className="price">₹{numberWithCommas(el?.rooms?.[0]?.grandTotal)}</div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        {/* <button type='button' onClick={() => handlePage('travellers')} className="btn continueBtn">Continue</button> */}
                        <button
                            type='button'
                            disabled={location?.state?.isRetryPayment}
                            onClick={() => handleContinue(false, el)}
                            className="btn continueBtn"
                        >
                            Continue
                        </button>
                        {
                            el?.rooms?.[0]?.isRefundable && checkLastCancellationDateForHold(el) &&
                            <button type='button'
                                disabled={location?.state?.isRetryPayment}
                                onClick={() => handleContinue(true, el)}
                                className="btn continueBtn mt-2"
                            > Hold Reservation </button>
                        }
                    </div>
                    <HotelAddTravellerForm
                        setFormValue={setFormValue}
                        formValue={formValue}
                        setFormError={setFormError}
                        formError={formError}
                        setInsertCollection={setInsertCollection}
                        insertCollection={insertCollection}
                        setInitialData={setInitialData}
                        initialData={initialData}
                        setIntOtherData={setIntOtherData}
                        intOtherData={intOtherData}
                        handleContinue={handleContinue}
                        setPassengersData={setPassengersData}
                        hoteldata={el}
                    />
                </div>
            ))}

            {isOpenImage && (
                <>
                    <Lightbox
                        slides={srcImage}
                        open={indexImage >= 0}
                        index={indexImage}
                        close={() => { setIndexImage(-1); setIsOpenImage(false); setSrcImage([]); }}
                        plugins={[Zoom]}
                        zoom={{
                            zoomInMultiplier: 2,
                            doubleTapDelay: 300,
                            doubleClickDelay: 300,
                            doubleClickMaxStops: 2,
                            keyboardMoveDistance: 50,
                            wheelZoomDistanceFactor: 100,
                            pinchZoomDistanceFactor: 100,
                            maxZoomPixelRatio: 5,
                        }}
                    />
                </>
            )}

            <HotelGalleryViewModel
                // travelRoomDetail={propertyDetailsData}
                galleryViewData={galleryViewData}
                galleryviewModal={galleryviewModal}
                setGalleryViewModal={setGalleryViewModal}
            ></HotelGalleryViewModel>
        </>
    )
}

export default BookingRoomDetails;